import PortOpeningRuleOnPrem from '../../../models/entities/PortOpeningRuleOnPrem';
import { OnPremPortOpeningRequestsTypes } from '../../../models/enums/POR/OnPremPortOpeningRequestsTypes';

export type PORColumn = {
	header: string;
	cell: (rule: PortOpeningRuleOnPrem) => string;
	limit?: number;
};

export const RuleColumnsLayout = new Map<OnPremPortOpeningRequestsTypes, PORColumn[]>();

RuleColumnsLayout.set(OnPremPortOpeningRequestsTypes.InternetDMZ, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRuleOnPrem) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRuleOnPrem) => rule.name,
		limit: 40,
	},
	{
		header: 'Type',
		cell: (rule: PortOpeningRuleOnPrem) => rule.isTemporary.toString() == 'true' ? 'Temporary' : 'Permanent',
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRuleOnPrem) => rule.action?.name,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRuleOnPrem) => rule.sourceIPs,
		limit: 15,
	},
	{
		header: 'Source Objects',
		cell: (rule: PortOpeningRuleOnPrem) => rule.sourceObjects,
		limit: 15,
	},
	{
		header: 'Dest. URLs',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationURLs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationIPs,
		limit: 15,
	},
	{
		header: 'Dest. Objects',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationObjects,
		limit: 15,
	},
	{
		header: 'Dest. Ports',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationPorts,
	},
	{
		header: 'Protocol',
		cell: (rule: PortOpeningRuleOnPrem) => rule.protocol,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRuleOnPrem) => rule.description,
		limit: 20,
	},
]);

RuleColumnsLayout.set(OnPremPortOpeningRequestsTypes.InternalCertConnection, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRuleOnPrem) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRuleOnPrem) => rule.name,
		limit: 40,
	},
	{
		header: 'Type',
		cell: (rule: PortOpeningRuleOnPrem) => rule.isTemporary.toString() == 'true' ? 'Temporary' : 'Permanent',
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRuleOnPrem) => rule.action?.name,
	},
	{
		header: 'Source Objects',
		cell: (rule: PortOpeningRuleOnPrem) => rule.sourceObjects,
		limit: 40,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRuleOnPrem) => rule.sourceIPs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationIPs,
		limit: 15,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationPorts,
	},
	{
		header: 'Dest. Objects',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationObjects,
		limit: 40,
	},
	{
		header: 'Source. Env',
		cell: (rule: PortOpeningRuleOnPrem) => rule.sourceEnvironment,
		limit: 40,
	},
	{
		header: 'Dest. Env',
		cell: (rule: PortOpeningRuleOnPrem) => rule.destinationEnvironment,
		limit: 40,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRuleOnPrem) => rule.description,
		limit: 20,
	},
	{
		header: 'Protocol',
		cell: (rule: PortOpeningRuleOnPrem) => rule.protocol,
	},
]);
